import FormFieldLineLayout from "../../../../../../components/layouts/form-field-line-layout/form-field-line-layout";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../components/inputs/input/input";
import ReturnMethodStore from "../../../../stores/return-method-store";
import { observer } from "mobx-react";
import { IOption, SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface Props {
    returnMethod: ReturnMethodStore;
    validationGroup: IValidationGroup;
}

const CustomAddressFields: React.FC<Props> = observer(({returnMethod, validationGroup}: Props) =>{
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-return-method-editor';
    
    const countriesOptionsList: IOption[] = returnMethod.getCountriesOptionsList();
    const selectedCountry: IOption | undefined = countriesOptionsList.find(country => country.value === returnMethod.returnAddress?.countryCode);
    const onCountrySelect = (country: IOption) => {
        returnMethod.returnAddress?.setCountry(country.label);
        returnMethod.returnAddress?.setCountryCode(country.value as string);
    };

    return (
        <FormFieldLineLayout>
            <FormFieldLine
                label={getTranslation("ADDRESS_NAME", scope)}
                required={true}
            >
                <Input
                    value={returnMethod.returnAddress?.name ?? undefined}
                    placeholder={getTranslation("ENTER_AN_ADDRESS_NAME", scope)}
                    onChange={(v)=>{returnMethod.returnAddress?.setName(v)}}
                    required
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("WAREHOUSE_COMPANY_NAME", scope)}
                required={true}
            >
                <Input
                    value={returnMethod.returnAddress?.company ?? undefined}
                    placeholder={getTranslation("ENTER_A_COMPANY_NAME", scope)}
                    onChange={(v)=>{returnMethod.returnAddress?.setCompany(v)}}
                    required
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("ADDRESS_LINE_1", scope)}
                required={true}
            >
                <Input
                    value={returnMethod.returnAddress?.line1 ?? undefined}
                    placeholder={getTranslation("ENTER_YOUR_ADDRESS", scope)}
                    onChange={(v)=> returnMethod.returnAddress?.setLine1(v)}
                    required
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("ADDRESS_LINE_2", scope)}
            >
                <Input
                    value={returnMethod.returnAddress?.line2 ?? undefined}
                    placeholder={getTranslation("ENTER_YOUR_ADDRESS", scope)}
                    onChange={(v)=> returnMethod.returnAddress?.setLine2(v)}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("CITY", scope)}
                required={true}
            >
                <Input
                    value={returnMethod.returnAddress?.city ?? undefined}
                    placeholder={getTranslation("ENTER_YOUR_CITY_NAME", scope)}
                    onChange={(v)=> returnMethod.returnAddress?.setCity(v)}
                    required
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("STATE_PROVINCE_REGION", scope)}
            >
                <Input
                    value={returnMethod.returnAddress?.state ?? undefined}
                    placeholder={getTranslation("ENTER_YOUR_STATE_PROVINCE_REGION", scope)}
                    onChange={(v)=> returnMethod.returnAddress?.setState(v)}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("STATE_PROVINCE_CODE", scope)}
            >
                <Input
                    value={returnMethod.returnAddress?.stateCode ?? undefined}
                    placeholder={getTranslation("ENTER_YOUR_STATE_PROVINCE_CODE", scope)}
                    onChange={(v)=> returnMethod.returnAddress?.setStateCode(v)}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("POSTAL_CODE_ZIP", scope)}
                required={true}
            >
                <Input
                    value={returnMethod.returnAddress?.postalCode ?? undefined}
                    placeholder={getTranslation("ENTER_YOUR_POSTAL_CODE_ZIP", scope)}
                    onChange={(v)=> returnMethod.returnAddress?.setPostalCode(v)}
                    required
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("PHONE_NUMBER", scope)}
            >
                <Input
                    value={returnMethod.returnAddress?.phone ?? undefined}
                    placeholder={getTranslation("ENTER_YOUR_PHONE_NUMBER", scope)}
                    onChange={(v)=> returnMethod.returnAddress?.setPhone(v)}
                />
            </FormFieldLine>
            <FormFieldLine
                label={getTranslation("COUNTRY", scope)}
                required={true}
            >
                <SelectDropdown
                    value={selectedCountry}
                    options={countriesOptionsList}
                    onChange={(v)=> onCountrySelect(v as IOption)}
                    required
                    validationGroup={validationGroup}
                />
            </FormFieldLine>
        </FormFieldLineLayout>
    )
});

export default CustomAddressFields;
